<template>
  <div>
    <div class="list" v-for="(itme, index) in list" :key="index">
      <div class="list_title">{{ itme.title }}</div>
      <div
        class="list_main"
        v-for="(text, textindex) in itme.text"
        :key="textindex"
      >
        <div class="maintext">{{ text }}</div>
      </div>
    </div>
    <div class="list">
      <div class="list_title">医院电话</div>
      <div class="list_main">
        <div class="maintext">
          医院总机：<a href="wtai://wp//mc;0412-5837760">0412-5837760</a>
        </div>
        <div class="maintext">
          院办公室：<a href="wtai://wp//mc;0412-5818038">0412-58180380</a>
        </div>
        <div class="maintext">
          其他电话：<a href="wtai://wp//mc;0412-5858100">0412-5858100</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      list: [
        {
          title: '简介',
          text: [
            '鞍山市中医院坐落在风景秀美的千山脚下，始建于1990年底。占地4.6万平方米，开放床位200张，是一所名医荟萃、医术精湛、科系齐全、设备先进、环境优美，集医疗、教学、科研、保健为一体的国家三级甲等中医院和全国示范中医院。',
            '医院现有职工368人，其中副主任医师以上职称50人，医学硕士研究生以上人员12人。医院开设了骨伤、骨病、血栓病、糖尿病、乳腺病、风湿、类风湿、胃肠病、肾病等30余个特色专科专病诊室。鞍山市中医药学会、针灸学会、中医药研究所均设在院内。医院是鞍山市磁共振诊断中心、鞍山市乳腺病防治中心、鞍山市中医集团眼科治疗中心、辽宁中医药大学教学医院。',
            '医院采取多种形式培养人才，招纳人才，使医院成为人才施展才能的平台。特别是近几年引进了诸多名医和专家，如显微外科、眼科、耳鼻喉科、儿科、肾病科等名医，增强了医院竞争力和社会影响力。',
          ],
        },
        {
          title: '科研成果',
          text: [
            '近几年，医院获省、市科技进步奖6项，科研成果30项，开展新技术、新项目69项。',
          ],
        },
        {
          title: '获奖荣誉',
          text: [
            '连续多年被省、市授予先进单位称号，2003年被评为诚信杯活动示范单位、省“文明单位”、省“职业道德建设标兵单位”省“规范化服务先进单位”。',
          ],
        },
        {
          title: '先进设备',
          text: [
            '医院先后投资3700余万元引进了核磁共振、螺旋CT、数控彩超、800mAX光机、日本TR-321型血液透析机、DBG-01型超滤机、德国F- S321全功能手术显微镜、美国系统中央监护仪、电子胃镜、美国MEDⅡ型椎间盘镜、显微外科手术系统等先进仪器设备，装备了CCU、ICU重症监护系统，使平均每床位医疗设备总值居省内同行前茅。',
          ],
        },
        {
          title: '医院地址',
          text: ['辽宁省鞍山市铁东区新营路15号'],
        },
      ],
    }
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
}
</script>

<style scoped>
.list {
  margin: 10px 10px;
}
.list_title {
  font-size: 20px;
  margin-bottom: 10px;
}
.list_title:before {
  width: 3.5px;
  height: 20px;
  background-color: rgb(56, 171, 187);
  content: '.';
  color: rgb(56, 171, 187);
  margin-right: 10px;
  display: inline-block;
}
.list_main {
  /* margin-top: 10px; */
}

.maintext {
  line-height: 22px;
  letter-spacing: 2px;
  margin-bottom: 5px;
}
</style>
